module.exports = __webpack_public_path__ + "static/media/24.ed38694c.svg";